import {
    AfterViewInit, ChangeDetectorRef,
    Component,
    ElementRef,
    HostListener,
    OnDestroy,
    OnInit, ViewChild
} from '@angular/core';
import { UserB } from 'app/pages/ok-admin/user-b/user-b';
import { HROUTES } from '../horizontal-menu/navigation-routes.config';
import {
    ROUTES_ADMIN,
    ROUTES_CONTACT_CONTAZZ,
    ROUTES_CUSTOMER,
    ROUTES_CUSTOMER_MEI,
    ROUTES_CUSTOMER_MIGRATION,
    ROUTES_CUSTOMER_MIGRATION_WELCOME,
    ROUTES_CUSTOMER_PROCESS_OPEN,
    ROUTES_NOT_READY,
    ROUTES_OPEN_COMPANY,
    ROUTES_OPER,
    ROUTES_PARTNER
} from './vertical-menu-routes.config';

import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { UserBService } from 'app/pages/ok-admin/user-b/user-b-service';
import { ProcessService } from 'app/pages/process/process/process-service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Subscription } from 'rxjs';
import { StorageUtils } from '../../utils/storage-utils';
import { customAnimations } from '../animations/custom-animations';
import { ConfigService } from '../services/config.service';
import { LayoutService } from '../services/layout.service';

@Component({
    selector: 'app-sidebar',
    templateUrl: './vertical-menu.component.html',
    animations: customAnimations,
    providers: [ProcessService]
})
export class VerticalMenuComponent implements OnInit, AfterViewInit, OnDestroy {

    @ViewChild('toggleIcon') toggleIcon: ElementRef;
    public menuItems: any[];
    level = 0;
    logoUrl = 'assets/img/logo-small.png';
    public config: any = {};
    protected innerWidth: any;
    layoutSub: Subscription;
    configSub: Subscription;
    perfectScrollbarEnable = true;
    collapseSidebar = false;
    resizeTimeout;
    user: UserB;
    needReload: Boolean
    workspace: string;
    constructor(
        private router: Router,
        public translate: TranslateService,
        private userService: UserBService,
        private layoutService: LayoutService,
        private configService: ConfigService,
        private cdr: ChangeDetectorRef,
        private deviceService: DeviceDetectorService,
        private storage: StorageUtils,
        private processService: ProcessService,
        private userBService: UserBService
    ) {
        this.config = this.configService.templateConf;
        this.innerWidth = window.innerWidth;
        this.isTouchDevice();
    }


    ngOnInit() {
        this.create()

    }

    create() {
        const loggedUser: UserB = this.storage.getLoggedUser()
        // console.log('LOGGED USER', loggedUser)
        this.userBService.loadUserB(loggedUser.id, (result, user) => {
            const validator = user.info && user.info["situation"]

            // Configuração do workspace baseado no papel do usuário
            if (user.type === 'CONTAZZ') {
                if (this.storage.getRoleId() === 'admin') {
                    this.workspace = 'main';
                } else if (this.storage.getRoleId() === 'oper') {
                    this.workspace = 'simples_lp';
                }
            } else {
                if (this.storage.getRoleId() === 'partner') {
                    this.workspace = 'partner';
                } else if (this.storage.getRoleId() === 'mei') {
                    this.workspace = 'mei';
                } else if (user.idObj == null) {
                    this.workspace = 'simples_lp';
                } else {
                    this.workspace = 'simples_lp';
                }
            }

            if (user.info && user.info["situation"]) {
                this.user = user;

                this.processService.loadByCompany(loggedUser.idObj, (result, process) => {
                    const doneSteps = process.validationSteps.filter(step => step.status === 'DONE').length;

                    if (doneSteps === 5) {
                        delete user.info["situation"];
                        console.log("user", user)
                        this.userBService.update(user, (result) => {
                            if (result.success) {
                                this.router.navigate(["/workspace/main"]);

                                setTimeout((() => {
                                    window.location.reload();
                                }).bind(this), 2000);

                            }
                        });
                    }
                });
            }



            if (user.info && user.info["processStatus"]) {

                this.user = user;
                //  console.log("logged user", loggedUser.idObj)
                this.processService.loadByCompany(loggedUser.idObj, (result, process) => {
                    console.log('PROCESSO', process)
                    const doneSteps = process.validationSteps.filter(step => step.status === 'DONE').length;

                    if (doneSteps === 5 && user.info["processStatus"] == "PENDING") {
                        user.info["processStatus"] = "DONE";
                        console.log("user", user)
                        this.userBService.update(user, (result) => {
                            if (result.success) {
                                this.router.navigate(["/workspace/main"]);

                                setTimeout((() => {
                                    window.location.reload();
                                }).bind(this), 2000);

                            }
                        });
                    }
                });
            }

            // if(validator && !user.info["processStatus"]) {
            //     console.log("PASSOU NO !PROCESS STATUS") 
            //     this.storage.urlHome(ROUTES_CUSTOMER_MIGRATION[0].path);
            //     window.location.href = ROUTES_CUSTOMER_MIGRATION[0].path
            // }    

            if (user.info == null) {
                if (user.type === 'CONTAZZ') {
                    if (this.storage.getRoleId() === 'admin') {
                        this.menuItems = ROUTES_ADMIN;

                    } else if (this.storage.getRoleId() === 'oper') {
                        this.menuItems = ROUTES_OPER;
                    }
                } else {
                    if (this.storage.getRoleId() === 'partner') {
                        this.menuItems = ROUTES_PARTNER;
                    } else if (this.storage.getRoleId() === 'mei') {
                        this.menuItems = ROUTES_CUSTOMER_MEI;
                    } else if (user.idObj == null) {
                        this.menuItems = ROUTES_CUSTOMER_PROCESS_OPEN;
                    } else {
                        this.menuItems = ROUTES_CUSTOMER;
                    }
                }
            }


            if (user.info["processStatus"] == "PENDING") {
                this.menuItems = ROUTES_CUSTOMER_MIGRATION_WELCOME;
            }
            else if (validator && user.info["processStatus"] == "DONE") {
                if (user.type === 'CONTAZZ') {
                    if (this.storage.getRoleId() === 'admin') {
                        this.menuItems = ROUTES_ADMIN;
                    } else if (this.storage.getRoleId() === 'oper') {
                        this.menuItems = ROUTES_OPER;
                    }
                } else {
                    if (this.storage.getRoleId() === 'partner') {
                        this.menuItems = ROUTES_PARTNER;
                    } else if (this.storage.getRoleId() === 'mei') {
                        this.menuItems = ROUTES_CUSTOMER_MEI;
                    } else if (user.idObj == null) {
                        this.menuItems = ROUTES_CUSTOMER_PROCESS_OPEN;
                    } else {
                        this.menuItems = ROUTES_CUSTOMER;
                    }
                }
            }

            // console.log('USUARIO LOGADO', user)
            if (validator && user.info["situation"] == "migration") {
                this.menuItems = ROUTES_CUSTOMER_MIGRATION;
            }
            else if (validator && user.info["situation"] == "NotReady") {
                this.menuItems = ROUTES_NOT_READY;
            }
            else if (validator && user.info["situation"] == "READY") {
                this.menuItems = ROUTES_OPEN_COMPANY;
            }
            else if (validator && user.info["situation"] == "OPEN_COMPANY") {
                this.menuItems = ROUTES_CONTACT_CONTAZZ;
            } else {
                if (user.type === 'CONTAZZ') {
                    if (this.storage.getRoleId() === 'admin') {
                        this.menuItems = ROUTES_ADMIN;
                    } else if (this.storage.getRoleId() === 'oper') {
                        this.menuItems = ROUTES_OPER;
                    }
                }
                else if (user.info["processStatus"] == "PENDING") {
                    this.menuItems = ROUTES_CUSTOMER_MIGRATION_WELCOME
                } else {
                    if (this.storage.getRoleId() === 'partner') {
                        this.menuItems = ROUTES_PARTNER;

                    } else if (this.storage.getRoleId() === 'mei') {
                        this.menuItems = ROUTES_CUSTOMER_MEI;
                    } else if (user.idObj == null) {
                        this.menuItems = ROUTES_CUSTOMER_PROCESS_OPEN;
                    } else {
                        this.menuItems = ROUTES_CUSTOMER;
                    }
                }
            }
        })
        this.cdr.detectChanges()
    }

    ngAfterViewInit() {

        this.configSub = this.configService.templateConf$.subscribe((templateConf) => {
            if (templateConf) {
                this.config = templateConf;
            }
            this.loadLayout();
            // this.cdr.markForCheck();

        });

        this.layoutSub = this.layoutService.overlaySidebarToggle$.subscribe(
            collapse => {
                if (this.config.layout.menuPosition === 'Side') {
                    this.collapseSidebar = collapse;
                }
            });

    }


    @HostListener('window:resize', ['$event'])
    onWindowResize(event) {
        if (this.resizeTimeout) {
            clearTimeout(this.resizeTimeout);
        }
        this.resizeTimeout = setTimeout((() => {
            this.innerWidth = event.target.innerWidth;
            this.loadLayout();
        }).bind(this), 500);
    }

    loadLayout() {

        if (this.config.layout.menuPosition === 'Top') { // Horizontal Menu
            if (this.innerWidth < 1200) { // Screen size < 1200
                this.menuItems = HROUTES;
            }
        }


        if (this.config.layout.variant === 'Dark') {
            this.logoUrl = 'assets/img/logo-dark.png';
        } else {
            this.logoUrl = 'assets/img/logo-small.png';
        }

        if (this.config.layout.sidebar.collapsed) {
            this.collapseSidebar = true;
            this.logoUrl = 'assets/img/logo-icon.png';
        } else {
            this.collapseSidebar = false;
        }
    }
    updateMenu(list: any[]) {
        this.menuItems = list
        this.cdr.detectChanges();
    }

    toggleSidebar() {
        const conf = this.config;
        conf.layout.sidebar.collapsed = !this.config.layout.sidebar.collapsed;
        this.configService.applyTemplateConfigChange({ layout: conf.layout });

        setTimeout(() => {
            this.fireRefreshEventOnWindow();
        }, 300);
    }

    fireRefreshEventOnWindow = function () {
        const evt = document.createEvent('HTMLEvents');
        evt.initEvent('resize', true, false);
        window.dispatchEvent(evt);
    };

    CloseSidebar() {
        this.layoutService.toggleSidebarSmallScreen(false);
    }

    isTouchDevice() {

        const isMobile = this.deviceService.isMobile();
        const isTablet = this.deviceService.isTablet();

        if (isMobile || isTablet) {
            this.perfectScrollbarEnable = false;
        } else {
            this.perfectScrollbarEnable = true;
        }

    }


    ngOnDestroy() {
        if (this.layoutSub) {
            this.layoutSub.unsubscribe();
        }
        if (this.configSub) {
            this.configSub.unsubscribe();
        }

    }

    checkAndNavigate(route: string[]): void {
        const url = this.router.url
        const restrictedUrls = ['/company/contact-contazz-company', '/company/welcome-migration', '/company/accounting-migration-complete']
       
        if (!restrictedUrls.includes(url)) {
            this.router.navigate(route);
        }
    }

}
